import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import { useTranslation } from "react-i18next";
import configureStore from "../../redux/store";
import ApiBaseURLProps from "../other/apiBaseURL";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { setDirStateError, setPanNo } from "../../redux/directorSlice";
import { useDispatch, useSelector } from "react-redux";
import LookupService from "../service/lookupService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  NON_DOCUMENT_DETAIL_DOCUMENT,
  filterDocument,
  filterCompanyDocument,
} from "./documentDetails";
import { Image } from "primereact/image";
import ErrorBlock from "./errorBlock";
import CustomImage from "../other/Image";

function ViewCompanyData(props) {
  const { t } = useTranslation();

  const data = configureStore.getState();
  const {
    companyName,
    ceoFirstName,
    ceoMiddleName,
    ceoLastName,
    secFirstName,
    secMiddleName,
    secLastName,
    companyTypeDesc,
    registrationDate,
    panVatRegistrationNo,
    typesOfBusinessOfCompanyDesc,
    areaOfWork,
    nameAddressOfCompany,
    isListed,
    listingDate,
    companyTypeOthers,
    businessTypeOthers,
    incorporationDate,
    countryOfRegistrationDesc,
    isSubsidiary,
    registrationNo,
    registrationOffice,
  } = data.companyDetails;
  const {
    country,
    countryDesc,
    state,
    stateDesc,
    district,
    districtDesc,
    municipality,
    municipalityDesc,
    ward,
    tole,
    blockNo,
    telephoneNo,
    emailId,
    mobileNo,
    perWard,
    perTole,
    perBlockNo,
    perTelephoneNo,
    perCountry,
    perState,
    perDistrict,
    perMunicipality,
    perCountryDesc,
    perStateDesc,
    perMunicipalityDesc,
    perDistrictDesc,
  } = data.addressDetails;
  const boidDetailList = data.boidDetails.boidList;
  const bankList = data.bankDetails.bankDetailsList;
  const directorDetailsList = data.directorDetails.directorDetailsList;
  const documentDetailList = data.documentDetails.documentList;
  const dynamicDatas = data.dynamicFieldDetails.allDynamicField;
  const dynamicDataList = Object.values(dynamicDatas).filter(v => v.value != null);

  const [type, setType] = useState();
  const [directorName, setDirectorName] = useState();
  const [designation, setDesignation] = useState();
  const [panNo, setPanNo] = useState();
  const [spouseName, setSpouseName] = useState();
  const [fatherName, setFatherName] = useState();
  const [grandFatherName, setGrandFatherName] = useState();
  const [dirCountry, setDirCountry] = useState();
  const [dirState, setDirState] = useState();
  const [dirDistrict, setDirDistrict] = useState();
  const [dirMunicipality, setDirMunicipality] = useState();
  const [dirPerCountry, setDirPerCountry] = useState();
  const [dirPerState, setDirPerState] = useState();
  const [dirPerDistrict, setDirPerDistrict] = useState();
  const [dirPerMunicipality, setDirPerMunicipality] = useState();
  const [dirWard, setDirWard] = useState();
  const [dirTole, setDirTole] = useState();
  const [dirBlockNo, setDirBlockNo] = useState();
  const [dirTelephoneNo, setDirTelphoneNo] = useState();
  const [dirEmailId, setDirEmailId] = useState();
  const [dirMobileNo, setDirMobileNo] = useState();
  const [dirPerWard, setDirPerWard] = useState();
  const [dirPerTelephoneNo, setDirPerTelphoneNo] = useState();
  const [dirPerTole, setDirPerTole] = useState();
  const [dirPerBlockNo, setDirPerBlockNo] = useState();
  const [dirDocumentList, setDirDocumentList] = useState();
  const { fdpId, fdpIdDesc, createBoid } = data.boidDetails;

  // const ldocumentTypeList = useSelector(
  //   (state) => state.lookupDetails.documentTypeList
  // );
  const ldistrictList = useSelector(
    (state) => state.lookupDetails.districtList
  );

  const dispatch = useDispatch();

  useEffect(() => {
    // if (!ldocumentTypeList) {
    //   LookupService.getDocumentTypeList(dispatch);
    // }
    if (!ldistrictList) {
      LookupService.getDistrictList(dispatch);
    }
  }, []);

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  const [dialogVisible, setDialogVisible] = useState(false);
  const convertDate = (oDate) => {
    if (!oDate) return "";

    let date = new Date(oDate);
    let yyyy = date.getFullYear();
    let mm = ("0" + (date.getMonth() + 1)).slice(-2);
    let dd = ("0" + date.getDate()).slice(-2);
    let formattedDate = yyyy + "-" + mm + "-" + dd;
    return formattedDate;
  };

  const openDialog = (rowData) => {
    setType(rowData.directorTypeDesc || rowData.type);
    setDirectorName(
      rowData.firstName +
      " " +
      (rowData.middleName ? rowData.middleName + " " : "") +
      " " +
      rowData.lastName
    );
    setDesignation(rowData.designation);
    setPanNo(rowData.panNo);
    setSpouseName(
      rowData.spouseFirstName +
      " " +
      (rowData.spouseMiddleName ? rowData.spouseMiddleName + " " : "") +
      " " +
      rowData.spouseLastName
    );
    setFatherName(
      rowData.fatherFirstName +
      " " +
      (rowData.fatherMiddleName ? rowData.fatherMiddleName + " " : "") +
      " " +
      rowData.fatherLastName
    );
    setGrandFatherName(
      rowData.grandFatherFirstName +
      " " +
      (rowData.grandFatherMiddleName
        ? rowData.grandFatherMiddleName + " "
        : "") +
      " " +
      rowData.grandFatherLastName
    );
    setDirCountry(rowData.countryDesc);
    setDirState(rowData.stateDesc);
    setDirDistrict(rowData.districtDesc);
    setDirMunicipality(rowData.municipalityDesc);
    setDirWard(rowData.ward);
    setDirBlockNo(rowData.blockNo);
    setDirTole(rowData.tole);
    setDirTelphoneNo(rowData.telephoneNo);
    setDirEmailId(rowData.emailId);
    setDirMobileNo(rowData.mobileNo);
    setDirPerCountry(rowData.perCountryDesc);
    setDirPerState(rowData.perStateDesc);
    setDirPerDistrict(rowData.perDistrictDesc);
    setDirPerMunicipality(rowData.perMunicipalityDesc);
    setDirPerWard(rowData.perWard);
    setDirPerBlockNo(rowData.perBlockNo);
    setDirDocumentList(rowData.documentList);
    setDirPerTole(rowData.perTole);
    setDirPerTelphoneNo(rowData.perTelephoneNo);

    setDialogVisible(true);
  };
  const history = useHistory();
  const permKycId = useSelector((state) => state.routerData.permKycId);
  const tempKycId = useSelector((state) => state.routerData.tempKycId);

  return (
    <Card className="p-col-12 p-md-12">
      <ErrorBlock />
      {tempKycId &&
        <div className="p-col-12 p-md-12">
          <div className="p-field p-col-12 p-md-6">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("kycId")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {permKycId || tempKycId}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
        </div>
      }
      <div className="p-field p-col-12 p-md-12 p-grid ">
        <div className="p-field p-col-12 p-md-6 ">
          <h4 className="p-col-12 p-md-12 p-pl-0">
            <p className="section-title">{t("companyDetails")}</p>
          </h4>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("companyName")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {companyName}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("incorporationDate")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {"" + convertDate(incorporationDate)}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("typesOfCompany")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {data.companyDetails.companyTypeDesc
                ? data.companyDetails.companyTypeDesc
                : data.companyDetails.companyType}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("countryOfRegistration")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {data.companyDetails.countryOfRegistrationDesc ||
                data.companyDetails.countryOfRegistration}{" "}
            </span>
          </div>
          {/* <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("registrationNo")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {registrationNo}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("registrationOffice")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {registrationOffice}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("registrationDate")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {"" + convertDate(registrationDate)}
            </span>
          </div> */}

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("panVatRegistrationNo")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {panVatRegistrationNo}
            </span>
          </div>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("isSubsidiary")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {isSubsidiary == true ? "YES" : "NO"}
            </span>
          </div>
        </div>
        <div className="p-field p-col-12 p-md-6 ">
          <h4 className="p-col-12 p-md-12 p-pl-0">
            <p className="section-title">{t("boidDetails")}</p>
          </h4>
          {boidDetailList.length !== 0 ?
            <DataTable value={boidDetailList} dataKey="doc">
              <Column field="boid" header={t("boid")}></Column>
              <Column
                body={(rowData) => {
                  return rowData.dpIdDesc || rowData.dpId;
                }}
                header={t("dpName")}
              ></Column>
            </DataTable>
            :
            <>            <div className="p-col-12 p-md-12">
              <div className="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("forwardToDp")} :
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {fdpIdDesc || fdpId}
                </span>
                <div style={{ clear: "both" }}></div>
              </div>
            </div>
              <div className="p-col-12 p-md-12">
                <div className="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("createBoid")} :
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {createBoid == true ? "Yes" : "No"}
                  </span>
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
            </>}
        </div>
        {isSubsidiary ? (
          <>
            <div className="p-field p-col-12 p-md-6 ">
              <div class="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("nameAddressOfCompany")}:
                </label>

                <span className="p-col-12 p-md-6 form-detail-data">
                  {nameAddressOfCompany}
                </span>
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6 ">
              <div class="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("typesOfBusinessCompany")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {data.companyDetails.typesOfBusinessOfCompanyDesc ||
                    data.companyDetails.typesOfBusinessOfCompany}
                </span>
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6 ">
              <div class="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("areaOfWork")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {areaOfWork}
                </span>
              </div>
            </div>
            <div className="p-field p-col-12 p-md-6 ">
              <div class="bdrTop">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("isListed")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {isListed == true ? "YES" : "NO"}
                </span>
              </div>
            </div>
            {isListed ? (
              <>
                <div className="p-field p-col-12 p-md-6 ">
                  <div class="bdrTop">
                    <label className="p-col-12 p-md-6 form-detail-label">
                      {t("listingDate")}:
                    </label>
                    <span className="p-col-12 p-md-6 form-detail-data">
                      {convertDate(listingDate)}
                    </span>
                  </div>
                </div>
              </>
            ) : null}
          </>
        ) : null}
        <h4 className="p-col-12 p-md-12">
          <p className="section-title">{t("addressDetails")}</p>
        </h4>

        <div className="p-field p-col-12 p-md-6 ">
          <h5 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
            <p className="section-sub-title">{t("currentAddress")}</p>
          </h5>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("country")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {countryDesc ? countryDesc : country}
            </span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("state")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {stateDesc ? stateDesc : state}
            </span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("district")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {districtDesc ? districtDesc : district}
            </span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("municipality")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {municipalityDesc ? municipalityDesc : municipality}
            </span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("ward")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{ward}</span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("tole")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{tole}</span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("blockNo")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{blockNo}</span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("telephoneNo")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">
              {telephoneNo}
            </span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("emailId")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{emailId}</span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("mobileNo")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{mobileNo}</span>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-6">
          <h5 className="p-col-12 p-md-12">
            <p className="subHeading">{t("permanentAddress")}</p>
          </h5>
          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("country")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perCountryDesc ? perCountryDesc : perCountry}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("state")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perStateDesc ? perStateDesc : perState}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("district")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perDistrictDesc ? perDistrictDesc : perDistrict}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("municipality")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perMunicipalityDesc ? perMunicipalityDesc : perMunicipality}
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

          <div className="p-field p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("ward")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perWard}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("tole")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perTole}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("blockNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perBlockNo}
              </span>
            </div>
          </div>
          <div className="p-field p-col-12 p-md-12 ">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("telephoneNo")} :
              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
                {perTelephoneNo}
              </span>
            </div>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-6 ">
          <h5 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
            <p className="section-sub-title">{t("location")}</p>
          </h5>
          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {" "}
              {t("gps")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{ }</span>
          </div>

          <div class="bdrTop">
            <label className="p-col-12 p-md-6 form-detail-label">
              {t("image")}:
            </label>
            <span className="p-col-12 p-md-6 form-detail-data">{ }</span>
          </div>
        </div>

        <div className="p-field p-col-12 p-md-12">
          <h4 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
            <p className="section-title">{t("directorDetails")}</p>
          </h4>
          <DataTable value={directorDetailsList}
            style={{ minWidth: 400 }} dataKey="bank">
            {/* <Column
              body={(rowData) => {
                return rowData.directorTypeDesc || rowData.type;
              }}
              header={t("type")}
            ></Column> */}
            <Column field="firstName" header={t("nameSurname")}></Column>
            <Column field="designation" header={t("designation")}></Column>
            <Column field="panNo" header={t("panNo")}></Column>
            <Column
              header={t("action")}
              body={(rowData) => (
                <i
                  className="pi pi-eye"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    console.log(rowData);
                    openDialog(rowData);
                  }}
                />
              )}
            ></Column>
          </DataTable>
          <Dialog
            header="View Director Details"
            visible={dialogVisible}
            style={{ width: "70%" }}
            onHide={() => setDialogVisible(false)}
          >
            <div className="p-grid p-fluid">
              {/* <div className="p-field p-col-12 p-md-6 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("type")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {type}
                  </span>
                </div>
              </div> */}
              <div className="p-field p-col-12 p-md-6 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("nameSurname")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {directorName}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <div class="bdrTop">
                  <label className="p-col-12 p-md-6 form-detail-label">
                    {t("designation")}:
                  </label>
                  <span className="p-col-12 p-md-6 form-detail-data">
                    {designation}
                  </span>
                </div>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("pan")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {panNo}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("spouseName")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {spouseName}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("fatherName")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {fatherName}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("grandFatherName")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {grandFatherName}
                </span>
              </div>
              <h5 className="p-col-12 p-md-12">
                <p className="section-title">{t("currentAddress")}</p>
              </h5>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("country")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirCountry}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("state")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirState}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("district")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirDistrict}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("municipality")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirMunicipality}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("ward")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirWard}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("tole")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirTole}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("blockNo")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirBlockNo}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("telephoneNo")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirTelephoneNo}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("emailId")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirEmailId}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {" "}
                  {t("mobileNo")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirMobileNo}
                </span>
              </div>
              <h5 className="p-col-12 p-md-12 form-detail-adress">
                <p className="section-title">{t("permanentAddress")}</p>
              </h5>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("country")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerCountry}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("state")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerState}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("district")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerDistrict}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("municipality")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerMunicipality}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("ward")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerWard}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("tole")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerTole}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {" "}
                  {t("blockNo")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerBlockNo}
                </span>
              </div>
              <div className="p-field p-col-12 p-md-6 ">
                <label className="p-col-12 p-md-6 form-detail-label">
                  {t("telephoneNo")}:
                </label>
                <span className="p-col-12 p-md-6 form-detail-data">
                  {dirPerTelephoneNo}
                </span>
              </div>

              <div className="p-field p-col-12 p-md-12 ">
                <DataTable
                  style={{ minWidth: 700 }} value={dirDocumentList} dataKey="doc">
                  <Column
                    field="documentTypeDesc"
                    header={t("documentType")}
                  ></Column>
                  <Column field="docId" header={t("docId")}></Column>
                  <Column
                    body={(rowData, index) => {
                      if (rowData.documentTypeId == "CZ")
                        return getDescription(
                          ldistrictList,
                          rowData.issuedFrom
                        );
                      else return rowData.issuedFromDesc || rowData.issuedFrom;
                    }}
                    header={t("issuedFrom")}
                  ></Column>
                  <Column
                    body={(rowData, index) => {
                      return ((rowData.issuedDate == null || rowData.issuedDate == "") ? ""
                        : new Date(rowData.issuedDate + 'EDT').toISOString().split("T")[0]);
                      // rowData.issuedDate &&
                      // (typeof rowData.issuedDate === "string"
                      //   ? rowData.issuedDate
                      //   : rowData.issuedDate.toISOString().split("T")[0])
                    }}
                    header={t("issuedDate")}
                  ></Column>
                  <Column
                    field="issuedDateBs"
                    header={t("issuedDateBs")}
                  ></Column>
                  <Column
                    style={{ width: 160 }}
                    body={(rowData, index) => {
                      return (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <CustomImage
                            src={
                              rowData.fileId
                                ? ApiBaseURLProps.apiBaseURL +
                                "/file/" +
                                rowData.fileId
                                : "/file_icon.png"
                            }
                            alt="Image Text"
                            width={80}
                            height={80}
                            preview
                          />
                          {rowData.backFileId && (
                            <CustomImage
                              src={
                                rowData.backFileId
                                  ? ApiBaseURLProps.apiBaseURL +
                                  "/file/" +
                                  rowData.backFileId
                                  : "/file_icon.png"
                              }
                              alt="Image Text"
                              width={80}
                              height={80}
                              preview
                            />
                          )}
                        </div>
                      );
                    }}
                    header={t("file")}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </Dialog>
        </div>

        <div className="p-field p-col-12 p-md-12">
          <h4 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
            <p className="section-title">{t("bankDetails")}</p>
          </h4>

          <DataTable
            style={{ minWidth: 600 }} value={bankList} dataKey="bank">
            <Column
              body={(rowData) => {
                return (
                  rowData.typesOfBankAccountDesc || rowData.typesOfBankAccount
                );
              }}
              header={t("typesOfBankAccount")}
            ></Column>

            <Column
              body={(rowData) => rowData.bankDesc || rowData.bank}
              header={t("bank")}
            ></Column>
            <Column
              body={(rowData) => {
                return rowData.bankBranchDesc || rowData.bankBranch;
              }}
              header={t("bankBranch")}
            ></Column>
            <Column
              field="bankAccountNumber"
              header={t("bankAccountNumber")}
            ></Column>
          </DataTable>
        </div>

        <div className="p-field p-col-12 p-md-12 ">
          <h4 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
            <p className="section-title">{t("documentDetails")}</p>
          </h4>
          {/* <DataTable
            value={documentDetailList.filter(
              (p) =>
                !NON_DOCUMENT_DETAIL_DOCUMENT.includes(p.documentTypeId) &&
                (formType === "I"
                  ? filterDocument(p, {
                      nationality,
                      isMinor,
                      isNrn,
                      documentForMinor,
                      locationType,
                    })
                  : filterCompanyDocument(p))
            )}
            dataKey="document"
          > */}
          <DataTable
            style={{ minWidth: 700 }} value={documentDetailList}>
            <Column
              field="documentTypeDesc"
              header={t("documentType")}
            ></Column>
            <Column field="docId" header={t("docId")}></Column>
            <Column
              body={(rowData, index) => {
                return rowData.issuedFromDesc || rowData.issuedFrom;
              }}
              header={t("issuedFrom")}
            ></Column>
            <Column
              body={(rowData, index) => {
                return ((rowData.issuedDate == null || rowData.issuedDate == "") ? ""
                  : new Date(rowData.issuedDate + 'EDT').toISOString().split("T")[0]);
                // rowData.issuedDate &&
                // (typeof rowData.issuedDate === "string"
                //   ? rowData.issuedDate
                //   : rowData.issuedDate.toISOString().split("T")[0])
              }}
              header={t("issuedDate")}
            ></Column>
            <Column field="issuedDateBs" header={t("issuedDateBs")}></Column>
            <Column
              style={{ width: 160 }}
              body={(rowData, index) => {
                return (
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <CustomImage
                      src={
                        rowData.fileId
                          ? ApiBaseURLProps.apiBaseURL +
                          "/file/" +
                          rowData.fileId
                          : "/file_icon.png"
                      }
                      alt="Image Text"
                      width={80}
                      height={80}
                      preview
                    />
                    {rowData.backFileId && (
                      <CustomImage
                        src={
                          rowData.backFileId
                            ? ApiBaseURLProps.apiBaseURL +
                            "/file/" +
                            rowData.backFileId
                            : "/file_icon.png"
                        }
                        alt="Image Text"
                        width={80}
                        height={80}
                        preview
                      />
                    )}
                  </div>
                );
              }}
              header={t("file")}
            ></Column>
          </DataTable>
        </div>
        {dynamicDataList && dynamicDataList.length !== 0 &&
          <div className="p-field p-col-12 p-md-12">
            <h4 className="p-col-12 p-md-12 p-pl-0 p-pr-0">
              <p className="section-title">{t("dynamicDetails")}</p>
            </h4>

            <DataTable value={dynamicDataList} dataKey="bank">
              <Column
                field="label"
              //  header={t("label")}
              ></Column>

              <Column
                body={(rowData) => rowData.value}
              //   header={t("value")}
              ></Column>

            </DataTable>
          </div>
        }
      </div>
    </Card>
  );
}

export default ViewCompanyData;
